import HistoricoVenda from './HitoricoVenda';

export default HistoricoVenda;